// stores/mainAppData.js
import { create } from 'zustand';

const useMainAppDataStore = create((set, get) => ({
  appDataMap: {}, // { [storeBusinessNumber]: { [yyyy-MM-dd]: appData } }

  // 저장
  setAppData: (storeBusinessNumber, date, data) =>
    set((state) => ({
      appDataMap: {
        ...state.appDataMap,
        [storeBusinessNumber]: {
          ...(state.appDataMap[storeBusinessNumber] || {}),
          [date]: data,
        },
      },
    })),

  // 조회
  getAppData: (storeBusinessNumber, date) =>
    get().appDataMap?.[storeBusinessNumber]?.[date] || null,
}));

export default useMainAppDataStore;
